import * as fromHeader from './header.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const reducers = fromHeader.reducer;

export const selectHeaderState = createFeatureSelector<any>('header');

export const getCounters = createSelector(selectHeaderState, fromHeader.getCountersNumbers);

export const getPageParams = createSelector(selectHeaderState, fromHeader.getPageParamsState);

export const getMeBadge = createSelector(selectHeaderState, fromHeader.getMeBadge);
